var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAuthenticated && _vm.commentable
    ? _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "row" }, [
          _vm.uploadstatus
            ? _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm._f("translate")("Uploading")) + "..."),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "progress mb-4",
                    attrs: {
                      role: "progressbar",
                      "aria-label": "Upload progress",
                      "aria-valuenow": _vm.uploadstatus,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100",
                    },
                  },
                  [
                    _c("div", {
                      staticClass:
                        "progress-bar progress-bar-striped progress-bar-animated",
                      style: `width: ${_vm.uploadstatus}%`,
                    }),
                  ]
                ),
              ])
            : _c("div", { staticClass: "col-12 d-flex" }, [
                _c(
                  "div",
                  { staticClass: "me-3" },
                  [_c("Avatar", { attrs: { user: _vm.student } })],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "w-100" }, [
                  _c("div", { staticClass: "mb-2" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.body,
                          expression: "body",
                        },
                      ],
                      ref: "autosize",
                      staticClass: "form-control comment--input",
                      attrs: { placeholder: _vm.$t("Add comment"), rows: "1" },
                      domProps: { value: _vm.body },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.body = $event.target.value
                          },
                          _vm.autosize,
                        ],
                        focus: _vm.showAdditionalOptions,
                        blur: _vm.hideAdditionalOptions,
                      },
                    }),
                    _vm._v(" "),
                    _vm.file
                      ? _c("div", { staticClass: "ratio ratio-16x9" }, [
                          _c("video", { attrs: { src: _vm.fileUrl } }),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between mb-2" },
                    [
                      _c("div", [
                        _vm.showOptions && !_vm.file
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-link text-secondary btn-sm",
                                  on: { click: _vm.addVideo },
                                },
                                [_c("i", { staticClass: "far fa-play-circle" })]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.file
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-link text-secondary btn-sm",
                                  on: { click: _vm.removeVideo },
                                },
                                [_c("i", { staticClass: "fas fa-trash" })]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.body.length > 0,
                              expression: "body.length > 0",
                            },
                          ],
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { disabled: _vm.commentNotValid },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.addComment.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("translate")("Send")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
        ]),
        _vm._v(" "),
        _vm.commentable.comments && _vm.commentable.comments.length
          ? _c(
              "div",
              _vm._l(_vm.commentable.comments, function (comment) {
                return _c("Comment", {
                  key: comment.id,
                  attrs: { comment: comment },
                  on: { commentRemoved: _vm.removeComment },
                })
              }),
              1
            )
          : _vm._e(),
      ])
    : _c(
        "div",
        { staticClass: "col-12 text-center" },
        [
          _c("p", { staticClass: "lead" }, [
            _vm._v(_vm._s(_vm._f("translate")("Want to see the comments?"))),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: `/${_vm.$route.params.course}/watch/login` } },
            [
              _vm._v(
                "\n    " + _vm._s(_vm._f("translate")("Log in now")) + "\n  "
              ),
            ]
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }